/**
 * Window event carrying a message for the header's mini-cart live region
 * (CPS-7696), so the island can announce its errors without sharing state
 * with the header, which owns the region.
 */
export const MINI_CART_ANNOUNCEMENT_EVENT = 'compass:mini-cart-announcement';

/** Takes a message back once what it said is no longer so. */
export const MINI_CART_WITHDRAWAL_EVENT = 'compass:mini-cart-withdrawal';

type MiniCartAnnouncementDetail = { message: string };

const dispatch = (type: string, message: string) => {
  window.dispatchEvent(
    new CustomEvent<MiniCartAnnouncementDetail>(type, { detail: { message } })
  );
};

const subscribe = (type: string, listener: (message: string) => void) => {
  const onEvent = (event: Event) =>
    listener((event as CustomEvent<MiniCartAnnouncementDetail>).detail.message);
  window.addEventListener(type, onEvent);
  return () => window.removeEventListener(type, onEvent);
};

/** Announces `message` politely through the header's live region. */
export const announceMiniCart = (message: string): void =>
  dispatch(MINI_CART_ANNOUNCEMENT_EVENT, message);

/** Clears `message` from the header's live region, if it still says it. */
export const withdrawMiniCartAnnouncement = (message: string): void =>
  dispatch(MINI_CART_WITHDRAWAL_EVENT, message);

/** The header subscribes here; returns the unsubscribe for an effect cleanup. */
export const subscribeToMiniCartAnnouncements = (
  listener: (message: string) => void
): (() => void) => subscribe(MINI_CART_ANNOUNCEMENT_EVENT, listener);

export const subscribeToMiniCartWithdrawals = (
  listener: (message: string) => void
): (() => void) => subscribe(MINI_CART_WITHDRAWAL_EVENT, listener);
